module.exports = __webpack_public_path__ + "static/media/diesel.ff0374fc.jpg";